import './assets/tailwind.css'
import './assets/main.css'
import './assets/algo.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.core.css'
import './assets/custom-quill.css'
import './assets/no-scrollbar.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from "@sentry/vue"

import App from './App.vue'
import router from './router'

const app = createApp(App)

const pinia = createPinia()

Sentry.init({
    app,
    dsn: "https://79e176551d9e48d0806d42688fa430db@glitch.algoresearch.id/3",
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
      Sentry.linkedErrorsIntegration({
        limit: 7
      })
    ],
    environment: import.meta.env.VITE_ENV || "production",
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    tracesSampleRate: 1.0,
  
    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/devapi\.algoresearch\.id\/gen-2/, /^https:\/\/backend\.algoresearch\.id\/v1\/client/],
  
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });

app.use(pinia)
// app.use(createPinia())
app.use(router)

app.mount('#app')
